import { c as _c } from "react/compiler-runtime";
import { getTranslations } from 'next-intl/server';
import { ServerCrash } from 'lucide-react';
import { RefreshButton } from '@/components/partials';
const ServiceUnavailablePageContent = async () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const t = await getTranslations();
    t0 = <div className="w-full space-y-6 text-center"><div className="space-y-3"><div className="mb-4 flex justify-center text-yellow-500"><ServerCrash className="h-20 w-20" /></div><h1 className="text-4xl font-bold tracking-tighter sm:text-5xl">503</h1><h2 className="mb-5 text-2xl font-semibold tracking-tight sm:text-3xl">{t("service_unavailable")}</h2><p className="text-gray-500">{t("server_error_description")}</p></div><RefreshButton label={t("try_again")} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default ServiceUnavailablePageContent;